import { NgModule } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterModule, RouterOutlet, Routes } from '@angular/router';
import { RedirectComponent } from './redirect/redirect.component';
import { ContextIdSelectorComponent } from './context-id-selector/context-id-selector.component';
import { PagesGuard } from './shared/pages.guard';
import { PlatformAvailabilityGuard } from './shared/platform-availability.guard';
import { SystemMonitoringComponent } from './system-monitoring/system-monitoring.component';
import { BrowserModule } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

const routes: Routes = [
  { path: "", component: RedirectComponent },
  { path: "logIn", loadChildren: () => import('./auth/log-in/log-in.module').then(m => m.LogInModule) },
  { path: "register", loadChildren: () => import('./auth/finish-registration/finish-registration.module').then(m => m.RegisterModule)},
  { path: "customer-register", loadChildren: () => import('./auth/register-customer/register-customer.module').then(m => m.RegisterCustomerModule)},
  { path: "reset-password", loadChildren: () => import('./auth/reset-password/reset-password.module').then(m => m.ResetPasswordModule)},
  { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  { path: 'system-monitoring', component: SystemMonitoringComponent, canActivate: [PlatformAvailabilityGuard] },
  { path:'selectContext', component: ContextIdSelectorComponent, canActivate:[PagesGuard]},
  { path:'selectContext/:contextId', component: ContextIdSelectorComponent, canActivate:[PagesGuard]},
  { path: '**', component: RedirectComponent },

]

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  
    BrowserModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    RouterOutlet, RouterLink, RouterLinkActive
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
